module.exports = "<p>produit-crm works!</p>\r\n"